module.exports = __webpack_public_path__ + "img/why-icon-active-1.5e15a81b.svg";